import { literal, number, object, union, z } from 'zod'

export const guideSchema = () =>
  object({
    orientation: union([literal('h'), literal('v')]),
    location: number(),
  })

export type Guide = z.infer<ReturnType<typeof guideSchema>>

export const slugifyGuide = ({ orientation, location }: Guide) => {
  return `${orientation}:${location}`
}
